import { withChildren } from '@builder.io/react'
import React from 'react'

/**
 * This is used with the AB test component to avoid CLS issues, it will show skeleton
 * components for the SSR rendered html only, it does not render after hydration.
 *
 * @param {object} props - The component props.
 * @param {React.ReactNode} props.children - The child components to be A/B tested.
 *
 * @returns {React.ReactElement} The randomly selected child component.
 */
const AbSkeleton = (props: any): React.ReactElement => {
  const { children = [], backgroundColor = '' } = props

  const isInIframe = () => {
    if (typeof window === 'undefined') return false
    try {
      return window.self !== window.top
    } catch (_err) {
      return true
    }
  }
  if (isInIframe()) {
    // Detect if in the builder editor iframe and show all child components for easier editing
    if (children.length === 0) return <div>Please add child skeleton components...</div>
    return <div style={{ backgroundColor }}>{children}</div>
  }

  // SSR
  if (typeof window === 'undefined') return <div style={{ backgroundColor }}>{children}</div>

  // Do not show in hydrated browser
  return <div></div>
}

const builderChildren = withChildren(AbSkeleton)
export default builderChildren
